import client from "./client";

export default {
    async getCounties(filters) {
        return client.parseResponse(await client.get('/counties', filters));
    },

    async createCounties(data) {
        return client.parseResponse(await client.post('/counties', data))
    },

    async getCounty(id) {
        return client.parseResponse(await client.get('/counties/' + id));
    },

    async editCounty(data) {
        return client.parseResponse(await client.put('/counties/' + data.id, data))
    },
    async deleteCounty(data) {
        return client.parseResponse(await client.delete('/counties/' + data.id))
    }
}
